import { gql } from '@apollo/client';

const DEFAULT_SORT_BY: SortField = { field: 'date', sort: 'desc' };

const buildQuery = ({
  dataType,
  filters,
  dateScope,
  sortBy,
}: RelatedDocumentsTypes.FetchDocumentsArgs) => ({
  query: gql`
    query FetchRecords(
      $dataType: String!
      $filters: [FilterInput]!
      $dateScope: [DateRangeInput!]!
      $sortBy: [SortField]
    ) {
      fetchRecords(
        dataType: $dataType
        filters: $filters
        dateScope: $dateScope
        sortBy: $sortBy
      )
    }
  `,
  variables: {
    dataType,
    filters,
    dateScope,
    sortBy: sortBy ?? DEFAULT_SORT_BY,
  },
});

const fetchRecords = async ({
  dataType,
  dateScope,
  filters,
  client,
  sortBy,
}: RelatedDocumentsTypes.FetchDocumentsArgs): Promise<ElasticDocument[]> => {
  const query = buildQuery({
    dataType,
    filters,
    dateScope,
    client,
    sortBy,
  });
  const response = await client.query(query);
  return response.data.fetchRecords;
};

export default fetchRecords;
